import React from "react";
import { Choice } from "../story";
import { getTextContent } from ".";
import titleFooter from "../assets/divider-brown.png"
import textPlaceholder from "../assets/text-placeholder.png"

/**
 * @param {Choice} choice - The choice selected by the user.
 * @param {scrollId} scrollId - If this element is the most recent storyBeat, scrolling behavior will wait for the element with this ID to load before starting.
 */
interface ConsequenceBlockProps {
    choice: Choice
    scrollId: string
}

/** Parses a single choice into a format that displays the results of that choice. It determines whether an image is included
 * and whether or not the energy modifier value should be displayed.
 * @param {ConsequenceBlockProps} props - Properties expected by a ConsequenceBlock.
*/
export const ConsequenceBlock = (props: ConsequenceBlockProps) => {
    const { choice, scrollId } = props;

    const renderByConsequenceMediaStatus = () => {
        if (choice.consequenceMedia) {
            return (
                <>
                <h1>
                    {choice.choiceText}
                    <img src={titleFooter} alt=""/>
                </h1>
                {getModifier()}
                <div className="fade-edges">
                    <img id={scrollId} 
                     src={require(`../assets/images/${choice.consequenceMedia}`)} 
                    alt={`Story illustration: ${choice.consequenceMedia}`}/>
                </div>
                </>
            );
        }
        return (
            <>
            <h1>
                {choice.choiceText}
                <img id={scrollId} src={titleFooter} alt=""/>
            </h1>
            {getModifier()}
            </>
        );

    }

    const getModifier = () => {
        if (choice.energyModifier === 0){
            return <></>;
        }

        const isEnergyGain = choice.energyModifier > -1;
        const energyColor = isEnergyGain? "green" : "red";
        const energySymbol = isEnergyGain ? "+" : "";

        return (
            <h1 style={{color:`${energyColor}`, paddingTop: 0, paddingBottom: 0}}>
                {energySymbol}{choice.energyModifier} ENERGY
            </h1>
        );
    }
    
    return (
        <>
        {renderByConsequenceMediaStatus()}
        <div className="text-section">
            {getTextContent(choice.consequenceText)}
            <img id={`${scrollId}-end`} src={textPlaceholder} alt=""/>
        </div>
        </>
    );
}